// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".privacy-policy[data-v-7dfb4232]{max-width:800px;margin:0 auto;padding:1em}.privacy-policy[data-v-7dfb4232]  h1{font-size:2em;margin-top:1em}.privacy-policy[data-v-7dfb4232]  h2{font-size:1.75em}.privacy-policy[data-v-7dfb4232]  h3{font-size:1.5}.privacy-policy[data-v-7dfb4232]  h4{font-size:1.25}.privacy-policy[data-v-7dfb4232]  h5{font-size:1.1;font-weight:bold}", ""]);
// Exports
module.exports = exports;
